import React from 'react';
import clsx from 'clsx';

interface CardProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  hover?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  header,
  footer,
  hover = false,
  className,
  children,
}) => {
  return (
    <article
      className={clsx(
        'rounded-panel border border-agentic-gray-200 bg-white p-6 shadow-card',
        hover && 'transition-shadow hover:shadow-md',
        className
      )}
    >
      {header}

      {(title || subtitle) && (
        <header className="mb-4">
          {title ? <h3 className="text-xl font-semibold text-agentic-text-primary">{title}</h3> : null}
          {subtitle ? <p className="mt-1 text-sm text-agentic-text-secondary">{subtitle}</p> : null}
        </header>
      )}

      <div className="min-w-0 text-agentic-text-primary">{children}</div>

      {footer ? <footer className="mt-4 border-t border-agentic-gray-200 pt-4">{footer}</footer> : null}
    </article>
  );
};
